const GRADIENTS = [
  'from-codialis-sky to-codialis-blue',
  'from-emerald-500 to-teal-600',
  'from-amber-500 to-orange-600',
  'from-purple-500 to-fuchsia-600',
  'from-pink-500 to-rose-600',
  'from-rose-500 to-red-600',
  'from-blue-500 to-indigo-600',
] as const;

/** Couleur stable par personne, sans dépendre d'une donnée renvoyée par l'API. */
export function gradientPour(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  return GRADIENTS[hash % GRADIENTS.length] ?? 'from-codialis-sky to-codialis-blue';
}
